export default __webpack_public_path__ + "static/media/mediumLogo.7cefe816.svg";